/*
 * @Author: chenhe ch10@meitu.com
 * @Date: 2025-10-13 10:41:57
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-10-17 21:55:59
 * @FilePath: /roboneo-web/packages/roboneo-sdk/src/pages/RoboneoChatBoard/components/ChatSkeleton/index.tsx
 * @Description: 使用远程 Lottie JSON（根据主题切换）
 */
import React from 'react';
import Lottie from 'lottie-react';
import darkJson from './dark.json';
import lightJson from './light.json';

function ProductListLoading({ theme = 'dark' }: { theme: 'light' | 'dark'; }) {
  return (
    <Lottie animationData={theme === 'dark' ? darkJson : lightJson} height={700} />
  );
}

export default ProductListLoading;
